"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REPAYMENT_BANK = exports.DISBURSAL_BANK = exports.CUSTOMER_CONTACTS = exports.ACCOUNT_INFO = exports.VIRTUAL_BANK = exports.CUSTOMER_INFO = void 0;
exports.CUSTOMER_INFO = 'CUSTOMER_INFO';
exports.VIRTUAL_BANK = 'VIRTUAL_BANK';
exports.ACCOUNT_INFO = 'ACCOUNT_INFO';
exports.CUSTOMER_CONTACTS = 'CUSTOMER_CONTACTS';
exports.DISBURSAL_BANK = 'DISBURSAL_BANK';
exports.REPAYMENT_BANK = 'REPAYMENT_BANK';
